import React, { useState } from 'react';
import { TextField, FormControl } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { StringKeys } from '../../../../resources/strings/StringKeys';
import BaseModal from '../../../../components/modals/BaseModal';

export default function EditProfileNameModal({ show, onHide, saveUserName }) {
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [validation, setValidation] = useState({});
  const { t } = useTranslation();

  const handleSave = () => {
    if (validateFields()) {
      saveUserName({
        first_name: firstName,
        last_name: lastName,
      });
      resetForm();
      onHide();
    }
  };

  const resetForm = () => {
    setValidation({});
    setFirstName('');
    setLastName('');
  };

  const validateFields = () => {
    let isValid = true;
    const newValidation = {};
    if (!firstName || firstName.trim().length === 0) {
      newValidation.firstName = 'error';
      isValid = false;
    }
    if (!lastName || lastName.trim().length === 0) {
      newValidation.lastName = 'error';
      isValid = false;
    }
    setValidation(newValidation);
    return isValid;
  };

  const handleClose = () => {
    onHide();
    resetForm();
  };

  return (
    <BaseModal
      open={show}
      onClose={handleClose}
      title={t(StringKeys.EDIT_NAME)}
      onSubmit={handleSave}
      submitButtonText={t(StringKeys.SAVE)}
      size="md"
      enableEnterKey={true}
    >
      <FormControl
        fullWidth
        margin="normal"
        error={validation.firstName === 'error'}
      >
        <TextField
          label={t(StringKeys.FIRST_NAME)}
          value={firstName}
          onChange={(e) => setFirstName(e.target.value)}
          error={validation.firstName === 'error'}
          helperText={
            validation.firstName === 'error' &&
            t(StringKeys.PLEASE_ENTER_A_VALID_FIRST_NAME)
          }
        />
      </FormControl>
      <FormControl
        fullWidth
        margin="normal"
        error={validation.lastName === 'error'}
      >
        <TextField
          label={t(StringKeys.LAST_NAME)}
          value={lastName}
          onChange={(e) => setLastName(e.target.value)}
          error={validation.lastName === 'error'}
          helperText={
            validation.lastName === 'error' &&
            t(StringKeys.PLEASE_ENTER_A_VALID_LAST_NAME)
          }
        />
      </FormControl>
    </BaseModal>
  );
}
